import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { textStyle } from '../../../uiComponents/text/styles'
import { getDetailedType } from '../../../checkoutV2/hooks/adyenCheckout'
import { RadioButtonWrapper, StyledInput, StyledLabel } from './sharedComponents'

const StyledParagraph = styled.span`
  ${textStyle}
  ${({ isOnlineBankingPL }) =>
    isOnlineBankingPL &&
    `
      .adyen-checkout__dropdown__button {
          width: auto;
          height: 16px;
      }
      .adyen-checkout__button.adyen-checkout__button--pay {
        display: none;
      }
      .adyen-checkout-disclaimer__label {
        margin-top: 4px
      }
  `}
`

const SwishStyledParagraph = styled(StyledParagraph)`
  > div {
    margin: 0 8px 8px;
  }
`

const TypeIcon = styled.span`
  margin-left: auto;
  background-repeat: no-repeat;
  padding-right: 8px;
  height: ${({ type }) => (type === 'applepay' ? 26 : 24)}px;
  width: 40px;
  background-blend-mode: darken;
  background-color: ${({ theme, selected }) =>
    selected ? theme.color.blue.shade10 : theme.color.grey.shade9};
  background-image: ${({ type }) =>
    `url('https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/${type}.svg')`};
  ${({ isOnlineBankingPL }) =>
    isOnlineBankingPL &&
    `margin-right: 8px;
    background-position: center;
  `}
  display: ${({ hidden }) => (hidden ? 'none' : 'inherited')};
`

const StoredCardIcon = ({ expiryMonth, expiryYear, lastFour }) => {
  return (
    <span
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 'auto',
        paddingRight: '8px'
      }}
    >
      <span style={{ fontSize: '8px', lineHeight: '10px' }}>
        {expiryMonth}/{expiryYear}
      </span>
      <span style={{ fontSize: '8px', lineHeight: '10px' }}>●●●● {lastFour}</span>
    </span>
  )
}

export const AdyenRadioButton = ({
  component,
  isSelected,
  hideUnselected,
  disabled,
  erroneous,
  paymentRefs,
  onSelect
}) => {
  const { t } = useTranslation('adyenSessionPayment')
  const detailedType = getDetailedType(component)
  const isOnlineBankingPL = detailedType === 'onlineBanking_PL'

  useEffect(() => {
    if (isSelected) {
      component.mount(paymentRefs[detailedType].current)
    }
  }, [isSelected, component, detailedType, paymentRefs])

  return (
    <RadioButtonWrapper
      disabled={disabled}
      hidden={hideUnselected && !isSelected}
      className={isSelected ? 'selected_payment_option' : ''}
    >
      <span style={{ display: 'flex' }}>
        <StyledInput
          hideButton={hideUnselected}
          checked={isSelected}
          name={name}
          onChange={onSelect}
          value={component._id}
          disabled={disabled}
          erroneous={erroneous}
        />
        <StyledLabel design='body1' noMargin $applePay={detailedType === 'applepay'}>
          {detailedType === 'saved_card' ? t('adyenOptions.saved_card.name') : component.props.name}
          {detailedType === 'saved_card' ? (
            <StoredCardIcon
              expiryMonth={component.props.expiryMonth}
              expiryYear={component.props.expiryYear}
              lastFour={component.props.lastFour}
            />
          ) : (
            <TypeIcon type={detailedType} isOnlineBankingPL={isOnlineBankingPL} />
          )}
        </StyledLabel>
      </span>
      {detailedType === 'swish' && (
        <SwishStyledParagraph
          noMargin
          design={'body4'}
          ref={paymentRefs[detailedType]}
          style={{
            display: !isSelected ? 'none' : 'block'
          }}
        />
      )}
      {/*
         Hide the mobilepay button since it do the same as our payment button.
        */}
      {detailedType === 'mobilepay' && (
        <StyledParagraph
          ref={paymentRefs[detailedType]}
          style={{
            display: 'none'
          }}
        />
      )}
      {!['paypal', 'swish', 'mobilepay', 'applepay'].includes(detailedType) && (
        <StyledParagraph
          noMargin
          design={'body4'}
          ref={paymentRefs[detailedType]}
          style={{
            margin:
              isSelected &&
              [
                'card',
                'saved_card',
                'swish',
                'ideal',
                'bcmc',
                'onlineBanking_PL',
                'applepay'
              ].includes(detailedType)
                ? '0 8px 8px 8px'
                : '0px',
            display: !isSelected ? 'none' : 'block'
          }}
          isOnlineBankingPL={isOnlineBankingPL}
        />
      )}
    </RadioButtonWrapper>
  )
}
